// extracted by mini-css-extract-plugin
export default {"search__bar":"styles_search__bar__vlaqW"};